import { render, staticRenderFns } from "./reportModalList.vue?vue&type=template&id=85f35b06&"
import script from "./reportModalList.vue?vue&type=script&lang=js&"
export * from "./reportModalList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports